import {JacksonType, JsonIdentityInfo} from "@sonner/jackson-service-v2";
import {SonnerBaseEntity} from "../modules/core/classes/sonner.base.entity";
import {ValueDisplayable} from "../modules/ui/interface/value.displayable";

@JacksonType("ClassificacaoTributariaIBSCBS")
@JsonIdentityInfo()
export class ClassificacaoTributariaIBSCBS extends SonnerBaseEntity implements ValueDisplayable{

  id: number;

  codigo: string;

  nome: string;

  descricao: string;

  reducaoIBS: number;

  reducaoCBS: number;

  getDisplayValue(): string {
    return this.codigo + " - " + this.nome;
  }

}
